class EventBus {
  constructor() {
    this.events = {};
  }

  /**
   * Subscribe to an event.
   * @param {string} event - The event name.
   * @param {Function} callback - The callback function.
   * @returns {Function} An unsubscribe function for easy cleanup.
   */
  subscribe(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    return () => this.unsubscribe(event, callback);
  }

  /**
   * Publish an event.
   * @param {string} event - The event name.
   * @param {any} data - The data to pass to subscribers.
   */
  publish(event, data) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in EventBus handler for ${event}:`, error);
        }
      });
    }
  }

  /**
   * Unsubscribe from an event.
   * @param {string} event - The event name.
   * @param {Function} callback - The callback to remove.
   */
  unsubscribe(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((cb) => cb !== callback);
    }
  }
}

export const eventBus = new EventBus();
